/* eslint-disable @typescript-eslint/no-empty-function */
import { useState } from 'react';

import { EyeIcon, EyeSlashIcon } from '@heroicons/react/20/solid';
import { useRouter } from 'next/router';

import Notification from '../components/notification';

import useRegister from '@/features/auth/hooks/useRegister';

export default function Register() {
  const [isShowPass, setIsShowPass] = useState(false);
  const [isShowPass2, setIsShowPass2] = useState(false);

  const [loading, setLoading] = useState(false);
  const { handleChangeValue, user, register } = useRegister();
  const router = useRouter();

  const currentQuery = router.query;

  const onRegister = async (e: React.FormEvent<HTMLButtonElement>) => {
    e.preventDefault();
    register();
  };

  return (
    <>
      <Notification />
      <div className="h-[100vh]">
        <div className="flex min-h-full">
          <div className="bg-primary-400 relative hidden w-0 flex-1 text-center text-white lg:block">
            <img
              className="mx-auto mt-20 object-cover"
              src="/ilustrations/Frame 48096039.png"
              alt=""
            />
            <h2 className="mt-6 text-3xl font-bold tracking-tight">Dialox</h2>
            <p className="mx-auto mt-6 max-w-lg">
              Escalating your service more professional in a single dashboard
              and help you achieve a good customer experience that brings a good
              impact for your business.
            </p>
          </div>
          <div className="flex flex-1 items-center">
            <div className="mx-auto w-full max-w-lg">
              <div className="text-center">
                <h2 className="mt-6 text-3xl font-bold tracking-tight text-neutral-800">
                  Create an account
                </h2>
                <p className="mt-5 text-base text-gray-600">
                  Create your account and enjoy our features
                </p>
              </div>

              <div className="mt-8">
                <div className="mt-6">
                  <form
                    className="space-y-6"
                    onSubmit={(e) => {
                      e.preventDefault();
                    }}
                    autoComplete="off"
                  >
                    <div className="mt-6 grid grid-cols-2 gap-y-6 gap-x-4">
                      <div>
                        <label className="block text-sm font-medium leading-6 text-gray-900">
                          First name
                        </label>
                        <div className="mt-2">
                          <input
                            type="text"
                            name="firstName"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            placeholder="Input first name"
                            onChange={handleChangeValue}
                            value={user.firstName}
                            required
                          />
                        </div>
                      </div>
                      <div>
                        <label className="block text-sm font-medium leading-6 text-gray-900">
                          Last name
                        </label>
                        <div className="mt-2">
                          <input
                            type="text"
                            name="lastName"
                            placeholder="Input last name"
                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                            onChange={handleChangeValue}
                            value={user.lastName}
                            required
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium leading-6 text-gray-900">
                        Username
                      </label>
                      <div className="mt-2">
                        <input
                          type="text"
                          name="username"
                          autoComplete="off"
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                          placeholder="Input username"
                          onChange={handleChangeValue}
                          value={user.username}
                          required
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium leading-6 text-gray-900">
                        Email
                      </label>
                      <div className="mt-2">
                        <input
                          placeholder="Input email"
                          name="email"
                          type="email"
                          required
                          className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                          onChange={handleChangeValue}
                          value={user.email}
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium leading-6 text-gray-900">
                        Phone Number
                      </label>
                      <div className="mt-2">
                        <input
                          type="text"
                          name="phoneNumber"
                          autoComplete="off"
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                          placeholder="Input phone number"
                          onChange={handleChangeValue}
                          value={user.phoneNumber}
                          required
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-sm font-medium leading-6 text-gray-900">
                        Workspace Name
                      </label>
                      <div className="mt-2">
                        <input
                          type="text"
                          name="workspaceId"
                          autoComplete="off"
                          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                          placeholder="Input workspace name"
                          onChange={handleChangeValue}
                          value={currentQuery?.workspace || ''}
                          disabled={currentQuery?.workspace ? false : true}
                        />
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor="password"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        Password
                      </label>
                      <div className="relative mt-2">
                        <input
                          placeholder="Input password"
                          name="password"
                          type={isShowPass ? 'text' : 'password'}
                          autoComplete="new-password"
                          required
                          className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                          onChange={handleChangeValue}
                        />
                        <div
                          onClick={() => setIsShowPass(!isShowPass)}
                          className="absolute inset-y-0 right-0 flex cursor-pointer items-center pr-3"
                        >
                          {isShowPass && (
                            <EyeSlashIcon className="h-5 w-5 text-gray-700" />
                          )}
                          {!isShowPass && (
                            <EyeIcon
                              className="h-5 w-5 text-gray-700"
                              aria-hidden="true"
                            />
                          )}
                        </div>
                      </div>
                    </div>
                    <div>
                      <label
                        htmlFor="passwordConfirm"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        Password Confirmation
                      </label>
                      <div className="relative mt-2">
                        <input
                          placeholder="Input confirm password"
                          name="passwordConfirm"
                          type={isShowPass2 ? 'text' : 'password'}
                          required
                          className="block w-full rounded-md border-0 py-1.5 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                          onChange={handleChangeValue}
                        />
                        <div
                          onClick={() => setIsShowPass2(!isShowPass2)}
                          className="absolute inset-y-0 right-0 flex cursor-pointer items-center pr-3"
                        >
                          {isShowPass2 && (
                            <EyeSlashIcon className="h-5 w-5 text-gray-700" />
                          )}
                          {!isShowPass2 && (
                            <EyeIcon
                              className="h-5 w-5 text-gray-700"
                              aria-hidden="true"
                            />
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <input
                          name="termcondition"
                          type="checkbox"
                          className="text-primary-600 focus:ring-primary-600 h-4 w-4 rounded border-gray-300"
                          required
                        />
                        <label
                          htmlFor="termcondition"
                          className="ml-2 block text-sm text-gray-900"
                        >
                          I agree to term & conditions
                        </label>
                      </div>
                    </div>

                    <div className="pb-10">
                      <button
                        disabled={loading}
                        type="submit"
                        className="bg-primary-100 text-primary-400 hover:bg-primary-300 flex w-full justify-center rounded-md py-2 px-3 text-sm font-semibold shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:cursor-not-allowed disabled:bg-indigo-300"
                        onClick={onRegister}
                      >
                        Sign Up
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
